module.exports = __webpack_public_path__ + "static/bg-12-76ad8ace97d80895a89f9319787cf5a2.jpg";